import { useCallback, useEffect, useMemo, useState } from 'react';
import { useCollectionData, useCollection } from 'react-firebase-hooks/firestore';
import firebase from 'firebase';

const POST_SIZE = 5;
const REVIEWS_COLLECTION_NAME = 'reviews';

const buildReviewsQuery = (postId, limit = null, lastItem = null) => {
    let query = firebase
        .firestore()
        .collection(REVIEWS_COLLECTION_NAME)
        .where('postUid', '==', postId)
        .orderBy('createdTimestamp');

    if (lastItem) {
        query = query.startAfter(lastItem.createdTimestamp);
    }

    if (limit) {
        query = query.limit(limit);
    }

    return query;
};

const firebaseOptions = {
    idField: 'uid',
};

export const useReviews = (postId, currentUserId) => {
    const [reviews, setReviews] = useState([]);
    const [lastReviewItem, setLastReviewItem] = useState(null);

    const [reviewsPage, isLoading] = useCollectionData(
        buildReviewsQuery(postId, POST_SIZE, lastReviewItem),
        firebaseOptions
    );

    const [reviewsSnapshot, isSnapshotLoading] = useCollection(buildReviewsQuery(postId));

    useEffect(() => {
        if (reviewsPage) {
            setReviews([...reviews, ...reviewsPage]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reviewsPage]);

    const count = useMemo(() => {
        return !isSnapshotLoading && reviewsSnapshot ? reviewsSnapshot.size : 0;
    }, [isSnapshotLoading, reviewsSnapshot]);

    const needShowLoadMoreButton = useMemo(() => count > reviews.length, [count, reviews.length]);

    const alreadyReviewed = useMemo(() => {
        let reviewed = false;
        if (reviewsSnapshot) {
            reviewsSnapshot.forEach(itemSnap => {
                if (itemSnap.data().publisherUid === currentUserId) {
                    reviewed = true;
                }
            });
        }

        return reviewed;
    }, [currentUserId, reviewsSnapshot]);

    const handleLastItemSet = useCallback(() => {
        setLastReviewItem(reviewsPage[reviewsPage.length - 1]);
    }, [reviewsPage]);

    return {
        onLastItemSet: handleLastItemSet,
        needShowLoadMoreButton,
        alreadyReviewed,
        isLoading,
        reviews,
        count,
    };
};
